import React, { PureComponent } from 'react';
import { ApplicationConfigForm } from '@comall-backend-builder/design-core';
import DetailTitle from '../../DetailTitle';
import './index.less';

/**
 * 可视化组件选择器
 */
export class ComponentSelector extends PureComponent<{ onSelect: (value: any) => void }> {
    state = {
        configForms: new Map(), // 全量组件（原来用）
        foundation: new Map(), // 基础组件
        commodity: new Map(), // 商品组件
        outcomponent: new Map(), // 历史组件（用于兼容使用）
    };

    componentDidMount() {
        const configForms = ApplicationConfigForm.getList();
        const foundation = new Map();
        const commodity = new Map();
        const outcomponent = new Map();
        // 商品数组
        const commodityKeys = ['productCard', 'pointProductCard', 'pointSwap', 'pointsDisplay'];
        // 历史组件
        const outcomponentKeys = [
            'title',
            'nav',
            'showcase',
            'products',
            'pointProducts',
            'imageAd',
        ];
        for (let [key, value] of configForms) {
            // 判断是否是商品组件
            if (commodityKeys?.includes(key)) {
                commodity.set(key, value);
            } else if (outcomponentKeys?.includes(key)) {
                outcomponent.set(key, value);
            } else {
                foundation.set(key, value);
            }
        }
        this.setState({ configForms, foundation, commodity, outcomponent });
    }

    handleClick = (name: any) => {
        const { onSelect } = this.props;
        return function() {
            if (onSelect) {
                onSelect(name);
            }
        };
    };

    // 获取基础组件
    getFoundationForms = () => {
        const { foundation } = this.state;
        let forms: any = [];
        foundation.forEach((item, i) => {
            if (i !== 'root') {
                forms.push(
                    <div key={i} className="item" onClick={this.handleClick(item.name)}>
                        {item.title}
                    </div>
                );
            }
        });
        return forms;
    };

    // 获取商品组件
    getCommodityForms = () => {
        const { commodity } = this.state;
        let forms: any = [];
        commodity.forEach((item, i) => {
            if (i !== 'root') {
                forms.push(
                    <div key={i} className="item" onClick={this.handleClick(item.name)}>
                        {item.title}
                    </div>
                );
            }
        });
        return forms;
    };

    // 获取历史组件
    getOutcomponentForms = () => {
        const { outcomponent } = this.state;
        let forms: any = [];
        outcomponent.forEach((item, i) => {
            if (i !== 'root') {
                forms.push(
                    <div key={i} className="item" onClick={this.handleClick(item.name)}>
                        {item.title}
                    </div>
                );
            }
        });
        return forms;
    };

    render() {
        const foundationForms = this.getFoundationForms();
        const commodityForms = this.getCommodityForms();
        const outcomponentForms = this.getOutcomponentForms();
        return (
            <div className="component-box">
                <DetailTitle label={`基础组件`} />
                <div className="component-selector">{foundationForms}</div>
                <DetailTitle label={`商品组件`} />
                <div className="component-selector">{commodityForms}</div>
                <DetailTitle label={`2023年之前的组件`} />
                <div className="component-selector">{outcomponentForms}</div>
            </div>
        );
    }
}
